import { createFileRoute } from '@tanstack/react-router'

import { BOILER_ROOM_DOMAIN } from '@/components/module-synoptic/module-synoptic-domain'
import { generateRouteOptions } from '@/components/module-synoptic/module-synoptic-route-options'

// Génération d'un synoptique de chaufferie. Garde OuiSense et préchargement du catalogue sont
// communs aux catégories de synoptiques à modules (cf. module-synoptic-route-options).
export const Route = createFileRoute('/_dashboard/site/$id/boiler-room/technical/generate/')(generateRouteOptions(BOILER_ROOM_DOMAIN))
